import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBed, FaMapMarkerAlt, FaRupee, FaPhone } from 'react-icons/fa';
import './Accommodation.css';

const Accommodation = () => {
  const navigate = useNavigate();
  
  const hotels = [
    {
      name: "Hotel K Fortune",
      address: "Nandyal Road, near G Pullareddy Engineering College, Siddartha Nagar, Kalluru, Andhra Pradesh 518007",
      phone: "085182 27222"
    },
    {
      name: "Hotel Triguna",
      address: "D no 51, 1 1a-4, Kallur Rd, behind RTC Bustand, Kallur, Sampath Nagar, Kurnool, Andhra Pradesh 518003",
      phone: "063019 58505"
    },
    {
      name: "Hotel DVR Mansion",
      address: "Plot No.40-839, SBI Circle Opp Children's Park, Andhra Pradesh 518004",
      phone: "085182 21111"
    },
    {
      name: "Maurya Inn",
      address: "40/304, Bhagya Nagar, River View Colony, Kurnool, Andhra Pradesh 518004",
      phone: "085182 24999"
    }
  ];
  
  return (
    <div className="accommodation-page">
      <div className="accommodation-container">
        <h1 className="accommodation-page-title-inline"><FaBed /> Accommodation</h1>

        <div className="accommodation-content">
          {/* Horizontal Section - On Campus & Important Info */}
          <div className="accommodation-horizontal-section">
            {/* Main Accommodation Card */}
            <div className="accommodation-card">
              <div className="accommodation-card-header">
                <FaMapMarkerAlt className="accommodation-card-icon" />
                <h2>On-Campus Accommodation</h2>
              </div>
              <div className="accommodation-card-body">
                <p className="accommodation-text">
                  Accommodation will be provided to participants in the <strong>Institute Campus Hostels</strong> on a <strong>payment basis</strong>, as per the institute's norms.
                </p>
                <p className="accommodation-text">
                  Details of accommodation charges will be updated on the conference website soon.
                </p>

                <h3 className="accommodation-subheading">Accommodation Details:</h3>
                <ul className="accommodation-features">
                  <li><strong>Location:</strong> IIITDM Kurnool Campus Hostels</li>
                  <li><strong>Basis:</strong> Payment basis as per institute norms</li>
                  <li><strong>Booking:</strong> Available after successful conference registration</li>
                  <li><strong>Charges:</strong> INR 250/- per day in the institute hostel</li>
                </ul>
                
                <h3 className="accommodation-subheading">Features:</h3>
                <ul className="accommodation-features">
                  <li>✓ Comfortable rooms with basic amenities</li>
                  <li>✓ Safe and secure campus environment</li>
                  <li>✓ Close proximity to conference venue</li>
                  <li>✓ On-campus dining facilities available</li>
                </ul>
              </div>
            </div>

            {/* Important Information */}
            <div className="accommodation-card accommodation-info-card">
              <div className="accommodation-card-header">
                <h3>Important Information</h3>
              </div>
              <div className="accommodation-card-body">
                <p className="accommodation-note">
                  <strong>Registration Required:</strong> Accommodation booking is available only after successful conference registration.
                </p>
                <p className="accommodation-note">
                  <strong>Booking Process:</strong> Upon completion of registration, participants can book accommodation through the conference portal.
                </p>
                <p className="accommodation-note">
                  <strong>Contact Us:</strong> For any accommodation-related queries, please contact the organizing committee at <strong>ncamst2026@iiitk.ac.in</strong> or <strong>+91-8518-289122/240</strong>
                </p>
                <div className="accommodation-cta">
                  <button className="accommodation-booking-button" onClick={() => navigate('/login')}>
                    📍 Book Accommodation Here
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Off-Campus Accommodation */}
          <div className="accommodation-card accommodation-offcampus-card">
            <div className="accommodation-card-header">
              <FaMapMarkerAlt className="accommodation-card-icon" />
              <h2>Off-Campus Accommodation Options</h2>
            </div>
            <div className="accommodation-card-body">
              <p className="accommodation-text">
                Participants can also choose to stay at nearby hotels <strong> at their own expense</strong>. Here are some recommended options:
              </p>

              <div className="hotels-grid">
                {hotels.map((hotel, index) => (
                  <div key={index} className="hotel-card">
                    <h3 className="hotel-name">{hotel.name}</h3>
                    <div className="hotel-info">
                      <p><strong>📍 Address:</strong></p>
                      <p className="hotel-address">{hotel.address}</p>
                    </div>
                    <div className="hotel-info">
                      <p><FaPhone className="phone-icon" /> <strong>Phone:</strong> <a href={`tel:${hotel.phone}`}>{hotel.phone}</a></p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accommodation;
